import axios from '@/components/api/axios';

async function getProductList(data) {
  const res = await axios.axiosGet('/api/nselection/getProductList');
  return res;
}

async function getDiscountInfo(orderData) {
  const res = await axios.axiosPost('/api/nselection/getDiscountInfo', orderData);
  return res;
}

async function getPaymentMethodList() {
  const res = await axios.axiosGet('/api/nselection/getPaymentMethodList');
  return res;
}

async function confirmOrder(orderData) {
  const res = await axios.axiosPost('/api/nselection/confirmOrder', orderData);
  return res;
}

async function createOrder(orderData) {
  const res = await axios.axiosPost('/api/nselection/createOrder', orderData);
  return res;
}

export default {
  getProductList,
  getDiscountInfo,
  getPaymentMethodList,
  confirmOrder,
  createOrder
}



// WEBPACK FOOTER //
// ./src/components/api/n-selection/n-selection.js